import {Milliseconds} from "../constans/milliseconds";
import Hls from "hls.js";

const TIME_FOR_MESSAGE_TO_ARRIVE = 30 * Milliseconds.SECOND;

export const getThingCameraPresenceTimeout = () => {
    return 10 * Milliseconds.MINUTE - TIME_FOR_MESSAGE_TO_ARRIVE;
};

export const getStreamUrlTimeout = () => {
    return 5 * Milliseconds.MINUTE - TIME_FOR_MESSAGE_TO_ARRIVE;
};

// These HLS error codes will be displayed to the user.
// Only include errors that are safe and appropriate for user visibility.
export const HLS_USER_VISIBLE_ERROR_CODES = [
    Hls.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
];
